import React from 'react';
import styled from 'styled-components';
import PpleLogo from '@src/assets/imgs/ppleLogo.png';
import Image from 'next/image';
import kakaoIcon from '@src/assets/imgs/kakaoIcon.svg';
import appleIcon from '@src/assets/imgs/appleIcon.svg';
import AuthContainer from '@src/components/Organism/Auth/AuthContainer';
import { TLoginBtn } from '@src/interfaces/Auth';
import { apiUrl } from '@src/utils/fetch';
import { AppleConfig } from '@src/data/apple.config';

const AuthPage = () => {
  const kakaoLogin = () => {
    window.location.href =
      'https://kauth.kakao.com/oauth/authorize?client_id=' +
      `${process.env.NEXT_PUBLIC_KAKAO_CLIENT_ID}` +
      '&redirect_uri=' +
      encodeURIComponent(
        `${apiUrl}/auth/kakao/callback?redirect=${window.location.origin}`
      ) +
      '&response_type=code';
  };
  const appleLogin = () => {
    const config = {
      client_id: AppleConfig.APPLE_SERVICE_ID, // This is the service ID we created.
      redirect_uri: 'https://pple.link/api/auth/apple', // As registered along with our service ID
      response_type: 'code id_token',
      state: 'origin:web', // Any string of your choice that you may use for some logic. It's optional and you may omit it.
      scope: 'name email', // To tell apple we want the user name and emails fields in the response it sends us.
      response_mode: 'form_post',
      m: 11,
      v: '1.5.4',
    };
    const queryString: string = Object.entries(config)
      .map(
        ([key, value]: [string, any]) => `${key}=${encodeURIComponent(value)}`
      )
      .join('&');
    location.href = `https://appleid.apple.com/auth/authorize?${queryString}`;
  };
  return (
    <FlexWrap>
      <FlexContent>
        <LogoWrap>
          <LoginLogo src={PpleLogo} alt="피플헌혈" height={56} priority />
        </LogoWrap>
        <LoginBtnWrap>
          <LoginBtn
            onClick={() => kakaoLogin()}
            style={{ marginBottom: 10 }}
            backgroundColor="#FEE500"
            color="black"
          >
            <KakaoLogo />
            카카오 로그인
          </LoginBtn>
          <LoginBtn
            backgroundColor="#222222"
            color="white"
            onClick={() => {
              appleLogin();
              // alert('준비중인기능입니다.')
            }}
          >
            <AppleLogo />
            Apple로 로그인
          </LoginBtn>
        </LoginBtnWrap>
      </FlexContent>
    </FlexWrap>
  );
};

const FlexContent = styled.div`
  width: 70%;
`;

const KakaoLogo = styled(kakaoIcon)`
  position: absolute;
  top: 50%;
  left: 4%;
  transform: translateY(-50%);
`;

const AppleLogo = styled(appleIcon)`
  position: absolute;
  top: 50%;
  left: 4%;
  transform: translateY(-50%);
  & > path {
    fill: ${({ theme }) => theme.commonColor.white};
  }
  width: 20px;
`;

const FlexWrap = styled.div`
  height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginBtn = styled.button<TLoginBtn>`
  background-color: ${(props) => props.backgroundColor};
  fill: ${(props) => props.fillColor};
  color: ${(props) => props.color};
  border-radius: 7px;
  font-weight: 700;
  font-size: 16px;
  display: block;
  padding: 15px 25px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
`;

const LoginBtnWrap = styled.div`
  width: 100%;
  margin-top: 50px;
`;

const LogoWrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const LogoTitle = styled.div`
  margin-top: 25px;
  color: ${({ theme }) => theme.commonColor.pink004};
  font-size: 16px;
`;
/** 아이콘+워드마크가 한 장에 들어 있어 기존 두 로고를 이걸로 대체했다. */
const LoginLogo = styled(Image)`
  width: auto !important;
  height: 56px !important;
  object-fit: contain;
`;

export default AuthPage;
